import { api } from "../../app/api";

export const statisticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMachinesByWilaya: builder.query({
      query: (lastSeen = false) => ({
        url: "statistics/machines-by-wilaya",
        params: { last_seen: lastSeen.toString() },
      }),
      providesTags: (result, error, lastSeen) => [
        { type: "Statistics", id: `wilaya-${lastSeen}` },
      ],
    }),
  }),
});

export const { useGetMachinesByWilayaQuery } = statisticsApi;
